export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const waitMinDelay = async <T extends any>(promise: Promise<T>, ms: number) => {
  const minDelayPromise = delay(ms);
  const res = await promise;
  await minDelayPromise;
  return res;
};
